/** Single source of truth for the EvoHR logo path. Update here to change everywhere. */
export const EVOHR_LOGO = "/evohr-logo.webp";
